import { render, staticRenderFns } from "./work-order-view-comments.vue?vue&type=template&id=3ad6a2ff&scoped=true"
import script from "./work-order-view-comments.vue?vue&type=script&lang=js"
export * from "./work-order-view-comments.vue?vue&type=script&lang=js"
import style0 from "./work-order-view-comments.vue?vue&type=style&index=0&id=3ad6a2ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad6a2ff",
  null
  
)

export default component.exports